import { useState } from 'react'
import { ArrowUpRight, Instagram } from 'lucide-react'
import { KLEDA_SOCIAL, socialLink } from '../lib/social'

export function SocialCard() {
  const [imageFailed, setImageFailed] = useState(false)

  return (
    <section aria-labelledby="social-kaart-titel" className="mt-lg overflow-hidden rounded-premium border border-track bg-white">
      {!imageFailed && (
        <a href={socialLink('instagram', 'client-card')} target="_blank" rel="noopener noreferrer" aria-label="Bekijk onze wasserij op Instagram" className="block">
          <img
            src={KLEDA_SOCIAL.image}
            alt={KLEDA_SOCIAL.imageAlt}
            width={1200}
            height={900}
            loading="lazy"
            className="w-full aspect-[3/1] object-cover"
            onError={() => setImageFailed(true)}
          />
        </a>
      )}
      <div className="p-md sm:p-lg">
        <p className="section-label mb-xs">Achter de schermen</p>
        <h2 id="social-kaart-titel" className="text-xl sm:text-2xl">Kijk mee in de wasserij</h2>
        <p className="mt-sm text-body-sm text-ink-soft leading-relaxed">
          Van het eerste schuim tot het schone resultaat. Op Instagram delen we wasfilmpjes en kleden voor en na de reiniging.
        </p>
        <div className="mt-md flex flex-wrap items-center gap-md">
          <a href={socialLink('instagram', 'client-card')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-sm rounded-full bg-mint-pale px-md py-sm text-body-sm font-semibold text-primary-dark hover:bg-mint-soft transition-colors">
            <Instagram size={18} aria-hidden="true" />
            Kijk mee op Instagram
            <ArrowUpRight size={16} aria-hidden="true" />
          </a>
          <a href={socialLink('facebook', 'client-card')} target="_blank" rel="noopener noreferrer" className="py-sm text-body-sm text-ink-soft underline underline-offset-4 hover:text-primary-dark">
            Liever Facebook?
          </a>
        </div>
      </div>
    </section>
  )
}
